(() => {
  const selectors = {
    slider: ".featuredReviews__items--slider",
    sliderDesktop: ".featuredReviews__items--sliderDesktop"
  }

  const slider = document.querySelectorAll(selectors.slider);
  const sliderDesktop = document.querySelectorAll(selectors.sliderDesktop);

  const slickSettings = {
    infinite: false,
    dots: true,
    arrows: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: false,
    centerMode: true,
    centerPadding: '18px',
    appendDots: $(".featuredReviews__slide-m-dots"),
    prevArrow: $(".featuredReviews__slide-m-prev"),
    nextArrow: $(".featuredReviews__slide-m-next"),
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 768,
        settings: "unslick"
      }
    ]
  };

  const slickSettingsDesktop = {
    infinite: false,
    dots: true,
    arrows: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    variableWidth: true,
    centerMode: false,
    appendDots: $(".featuredReviews__slide-m-dots"),
    prevArrow: $(".featuredReviews__slide-m-prev"),
    nextArrow: $(".featuredReviews__slide-m-next"),
    responsive: [
      {
        breakpoint: 768,
        settings: "unslick"
      }
    ]
  };

  $(slider).slick(slickSettings);
  $(sliderDesktop).slick(slickSettingsDesktop);

  window.addEventListener('resize', () => {
    $(slider).slick('resize');
    $(sliderDesktop).slick('resize');
  });
})();
